import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {UserEffects} from './effects/user.effects';
import * as fromUser from './reducers/user.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromUser.userFeatureKey, fromUser.reducer),
    EffectsModule.forFeature([UserEffects]),
  ],
})
export class UserStoreModule {
}
